import styled from "styled-components";

export const ActivityContainer = styled.div`
    flex: 1;
    min-height: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
`